<template>
  <v-dialog hide-overlay
            persistent
            v-model="dialog"
            width="360">
    <v-card>
      <v-card-text class="pa-6 d-flex align-center">
        <v-progress-circular class="mr-4"
                             color="primary"
                             indeterminate
                             size="28"
                             width="3" />
        <span>{{ $t('signingIn') }}</span>
      </v-card-text>
      <v-expand-transition>
        <v-card-actions v-show="showCancel">
          <v-spacer />
          <v-btn color="error"
                 text
                 v-on:click="cancel">
            {{ $t('cancel') }}
          </v-btn>
        </v-card-actions>
      </v-expand-transition>
    </v-card>
  </v-dialog>
</template>

<script>
import { signInCallbackMixin } from 'kayleen-vue-auth0-client'

export default {
  data: () => ({
    dialog: true,
    showCancel: false
  }),
  mixins: [ signInCallbackMixin ],
  mounted() {
    setTimeout(() => this.showCancel = true, 2000)
  },
  name: 'SignInCallback'
}
</script>

<i18n>
  {
    "de": {
      "cancel": "Abbrechen",
      "signingIn": "Anmeldung erfolgt…"
    },
    "en": {
      "cancel": "Cancel",
      "signingIn": "Signing in…"
    }
  }
</i18n>